import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { BaseControl } from '@uw/core/base-control';
import { map, takeUntil } from 'rxjs';
import { CheckboxOption } from './checkbox-option.model';
import { CheckboxComponent } from './checkbox.component';



@Component({
    selector: 'uw-multi-select-checklist',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    @for (formControl of controls; track formControl) {
      <uw-checkbox [formControl]="formControl"></uw-checkbox>
    }
    `,
    styles: [
        `
           :host {
             display: flex;
             width:100%;
             flex-direction: row;
             justify-content: space-between;
             flex-wrap: wrap;
           }
         `
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => MultiSelectChecklistComponent),
            multi: true
        }
    ],
    imports: [CheckboxComponent, ReactiveFormsModule]
})
export class MultiSelectChecklistComponent extends BaseControl {
  @Input("options") set options(value: { displayName: string, value: string }[]) {
    this.formArray.clear();
    for(let i = 0; i < value.length; i++) {
      this.formArray.push(new UntypedFormControl(value[i],[]));
    }
  }

  readonly formArray: UntypedFormArray = new UntypedFormArray([]);

  get controls() { return this.formArray.controls as UntypedFormControl[]; }

  writeValue(value: any[] = []): void {
    for(let i = 0; i < this.controls.length; i++) {
      const option = this.controls[i].value;
      option.checked = value?.indexOf(option.value) > -1;
      this.controls[i].setValue(option);
    }
  }

  registerOnChange(fn: any): void {
    this.formArray
    .valueChanges
    .pipe(
      takeUntil(this._destroyed$),
      map(value => value.filter((option: CheckboxOption) => option.checked).map((option: CheckboxOption) => option.value))
    ).subscribe(fn);
  }
}
